import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-evd',
  standalone: true,
  templateUrl: './help-evd.component.html',
  styleUrls: ['./help-evd.component.css'],
})
export class HelpEvdComponent {
  readonly parent = input.required<HelpComponent>();
}
